// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"eb5b0492","977":"bbbd9770"}[chunkId] + ".chunk.js";
};